import { NavBarTypes } from '../../../../sections/sitewide/components/NavBar/navBarTypes';
import { getClassesForNavBarLinks } from './NavLinkColorPicker';

export const ClassNameHelperNavBarLinks = (
  isCurrent: boolean,
  currentDetails: any,
  currTheme: NavBarTypes.TThemeModes,
  NavLinkText: string
) => {
  const { NavBarLinkColor, NavBarTextColor } = getClassesForNavBarLinks(
    currTheme
  );
  const getNavBarTextColorActiveClass = () => {
    return currTheme === 'light' ? 'primary' : 'secondary';
  };
  const activeClassHelper = () => {
    return `active navLinkCommon has-text-${getNavBarTextColorActiveClass()} cp-link-${NavBarLinkColor}`;
  };
  const genericClassHelper = () => {
    return `navLinkCommon has-text-${NavBarTextColor} cp-link-${NavBarLinkColor}`;
  };

  return {
    className:
      (isCurrent && currentDetails.activeComponent === NavLinkText) ||
      (isCurrent && location.pathname === '/') ||
      (isCurrent && location.pathname.includes('view-rates')) ||
      (isCurrent && location.pathname.includes('/account/login')) ||
      currentDetails.activeComponent === NavLinkText
        ? activeClassHelper()
        : genericClassHelper(),
  };
};
